import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Password } from "components/Form/components/Password/Password";

export const PasswordFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input
            fieldProps={{ ...fieldProps, clearable: false }} // TODO: remove clearable, this is a migration artifact
            fieldAttr={fieldAttr}
            input={input}
            meta={meta}
        >
            <Password
                name={input.name}
                touched={meta.touched ?? false}
                errorMessage={meta.error}
                input={input}
                attributes={fieldAttr}
                preventAutofill={fieldProps.preventAutofill}
            ></Password>
        </Input>
    );
};
